var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_4110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 54.2708V34.8958H36.6667",
    stroke: "#BD0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 54.8958H43.3334",
    stroke: "#BD0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1667 25.7292C39.3968 25.7292 39.5833 25.5426 39.5833 25.3125C39.5833 25.0824 39.3968 24.8958 39.1667 24.8958C38.9365 24.8958 38.75 25.0824 38.75 25.3125C38.75 25.5426 38.9365 25.7292 39.1667 25.7292Z",
    stroke: "#BD0000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8959 8.4375C48.2944 8.4375 56.349 11.7738 62.2876 17.7125C68.2263 23.6511 71.5626 31.7056 71.5626 40.1042V40.1042C71.5626 48.5027 68.2263 56.5572 62.2876 62.4959C56.349 68.4345 48.2944 71.7708 39.8959 71.7708V71.7708C31.4974 71.7708 23.4429 68.4345 17.5042 62.4959C11.5655 56.5572 8.22925 48.5027 8.22925 40.1042V40.1042C8.22925 31.7056 11.5655 23.6511 17.5042 17.7125C23.4429 11.7738 31.4974 8.4375 39.8959 8.4375V8.4375Z",
    stroke: "#BD0000",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1666 27.3875C40.3125 27.3875 41.2416 26.4585 41.2416 25.3125C41.2416 24.1665 40.3125 23.2375 39.1666 23.2375C38.0206 23.2375 37.0916 24.1665 37.0916 25.3125C37.0916 26.4585 38.0206 27.3875 39.1666 27.3875Z",
    fill: "#BD0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_4110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info_red.bf8952feb6799684a4a6d29c5c0e994b.svg";
export { ForwardRef as ReactComponent };